'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _get = require('lodash/get');
var constants = require('./constants.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);

var FUNDERS_WITH_ONBOARDING = [constants.FUNDERS.HICAPS, constants.FUNDERS.MEDICARE, constants.FUNDERS.ICARE, constants.FUNDERS.WCQ, constants.FUNDERS.COMCARE, constants.FUNDERS.WSV, constants.FUNDERS.NIB, constants.FUNDERS.QBE];
var CLAIMABLE_FUNDERS = [constants.FUNDERS.COMCARE, constants.FUNDERS.DVA, constants.FUNDERS.ECLIPSE, constants.FUNDERS.HEALTHPOINT, constants.FUNDERS.HICAPS, constants.FUNDERS.ICARE, constants.FUNDERS.MEDICARE, constants.FUNDERS.NIB, constants.FUNDERS.OHC, constants.FUNDERS.QBE, constants.FUNDERS.WCQ, constants.FUNDERS.WSV];
var getFunderCodeFromTransaction = function getFunderCodeFromTransaction(transaction, funderCode) {
  if (transaction.isPatientFunded || _get__default["default"](transaction, 'claims[0].isPatientFunded')) {
    return constants.FUNDERS.PATIENT;
  } else if (funderCode === constants.FUNDERS.HICAPS) {
    return constants.FUNDERS.HICAPS;
  } else if (funderCode === constants.FUNDERS.PATIENT) {
    return constants.FUNDERS.PATIENT;
  } else if (funderCode === constants.FUNDERS.MEDICARE) {
    return constants.FUNDERS.MEDICARE;
  } else if (funderCode === constants.FUNDERS.HBF) {
    return constants.FUNDERS.HBF;
  } else if (funderCode === constants.FUNDERS.ICARE) {
    return constants.FUNDERS.ICARE;
  } else if (funderCode === constants.FUNDERS.NDIS) {
    return constants.FUNDERS.NDIS;
  } else if (funderCode === constants.FUNDERS.OHC) {
    return constants.FUNDERS.OHC;
  } else if (funderCode === constants.FUNDERS.DVA) {
    return constants.FUNDERS.DVA;
  } else if (funderCode === constants.FUNDERS.WCQ) {
    return constants.FUNDERS.WCQ;
  } else if (funderCode === constants.FUNDERS.COMCARE) {
    return constants.FUNDERS.COMCARE;
  } else if (funderCode === constants.FUNDERS.HEALTHPOINT) {
    return constants.FUNDERS.HEALTHPOINT;
  } else if (funderCode === constants.FUNDERS.WSV) {
    return constants.FUNDERS.WSV;
  } else if (funderCode === constants.FUNDERS.NIB) {
    return constants.FUNDERS.NIB;
  } else if (funderCode === constants.FUNDERS.ECLIPSE) {
    return constants.FUNDERS.ECLIPSE;
  } else if (funderCode === constants.FUNDERS.QBE) {
    return constants.FUNDERS.QBE;
  }

  return constants.FUNDERS.PATIENT;
};
var isComcare = function isComcare(funderCode) {
  return funderCode === constants.FUNDERS.COMCARE;
};
var isDVA = function isDVA(funderCode) {
  return funderCode === constants.FUNDERS.DVA;
};
var isEclipse = function isEclipse(funderCode) {
  return funderCode === constants.FUNDERS.ECLIPSE;
};
var isHBF = function isHBF(funderCode) {
  return funderCode === constants.FUNDERS.HBF;
};
var isHICAPS = function isHICAPS(funderCode) {
  return funderCode === constants.FUNDERS.HICAPS;
};
var isIcare = function isIcare(funderCode) {
  return funderCode === constants.FUNDERS.ICARE;
};
var isHealthPoint = function isHealthPoint(funderCode) {
  return funderCode === constants.FUNDERS.HEALTHPOINT;
};
var isMedicare = function isMedicare(funderCode) {
  return funderCode === constants.FUNDERS.MEDICARE;
};
var isNDIS = function isNDIS(funderCode) {
  return funderCode === constants.FUNDERS.NDIS;
};
var isNib = function isNib(funderCode) {
  return funderCode === constants.FUNDERS.NIB;
};
var isOHC = function isOHC(funderCode) {
  return funderCode === constants.FUNDERS.OHC;
};
var isPatientFunded = function isPatientFunded(funderCode) {
  return funderCode === constants.FUNDERS.PATIENT;
};
var isQBE = function isQBE(funderCode) {
  return funderCode === constants.FUNDERS.QBE;
};
var isWCQ = function isWCQ(funderCode) {
  return funderCode === constants.FUNDERS.WCQ;
};
var isWSV = function isWSV(funderCode) {
  return funderCode === constants.FUNDERS.WSV;
}; // @ts-expect-error

var isFunderClaimable = function isFunderClaimable(funderCode) {
  return CLAIMABLE_FUNDERS.includes(funderCode);
};

exports.CLAIMABLE_FUNDERS = CLAIMABLE_FUNDERS;
exports.FUNDERS_WITH_ONBOARDING = FUNDERS_WITH_ONBOARDING;
exports.getFunderCodeFromTransaction = getFunderCodeFromTransaction;
exports.isComcare = isComcare;
exports.isDVA = isDVA;
exports.isEclipse = isEclipse;
exports.isFunderClaimable = isFunderClaimable;
exports.isHBF = isHBF;
exports.isHICAPS = isHICAPS;
exports.isHealthPoint = isHealthPoint;
exports.isIcare = isIcare;
exports.isMedicare = isMedicare;
exports.isNDIS = isNDIS;
exports.isNib = isNib;
exports.isOHC = isOHC;
exports.isPatientFunded = isPatientFunded;
exports.isQBE = isQBE;
exports.isWCQ = isWCQ;
exports.isWSV = isWSV;
